<template>
  <div>
    <div class="mass-edit-wrapper">
      <switch-checkbox
        :text="$t('common.mass-edit')"
        :onChange="toggleMassEdit"
        :checked="isMassEdit"
      />
    </div>

    <list-widget
      :items="users.items"
      routeName="user"
      :hideHeader="true"
      :changeRoute="true"
      :addNewTitle="$t('users.new_user')"
      addNewRouteName="add-user"
    >
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate
          :item="props.item"
          :isMassEdit="isMassEdit"
          :onClickCheckbox="addToCheckedList"
          :checked="isFindOnCheckedList(props.item.id)"
        ></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="users.items">
      <slot name="footer">
        <a
          class="link"
          v-on:click.stop.prevent="extendLimit()"
          v-if="users.total > users.items.length"
        >{{ $t('common.load_more') }}</a>

        <div class="footer-actions" v-if="checkedList.length">
          <div class="footer-actions__selected">{{ $t('common.selected') }}: {{checkedList.length}}</div>
          <div class="footer-actions__actions">
            {{ $t('common.actions') }}:
            <button
              type="button"
              class="btn btn--main btn--small"
              @click="showDeletingModal"
            >{{ $t('common.delete') }}</button>
            <button
              type="button"
              class="btn btn--small"
              @click="toggleMassEdit(false)"
            >{{ $t('common.discard') }}</button>
          </div>
        </div>
      </slot>
    </div>

    <ConfirmationModal
      v-if="showDeleteConfirmationModal"
      @cancel="hideDeletingModal"
      @confirmed="bulkDelete"
    >
      <h1 slot="header">{{ $t('common.deleting') }}: {{ checkedList.length }}</h1>
      <p slot="body">{{ $t('users.confirm_delete') }}</p>
    </ConfirmationModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListItemTemplate from 'users/ListItemTemplate';
import SwitchCheckbox from 'common/SwitchCheckbox';
import ConfirmationModal from 'common/ConfirmationModal';

export default {
  components: {
    ListWidget,
    ListItemTemplate,
    SwitchCheckbox,
    ConfirmationModal,
  },
  computed: mapGetters({
    users: 'landlord/users/users',
    usersLimit: 'landlord/users/limit',
    user: 'user/user/user',
  }),
  created() {
    this.fetchUsers();
    this.$store.commit(`landlord/users/${mTypes.SET_LIMIT}`, 10);
  },
  methods: {
    fetchUsers() {
      this.$store.dispatch('landlord/users/fetch', { keyword: this.$route.query.keyword, user: this.user })
        .then(() => {
          if (this.users.total === 0) {
            this.$router.push({ name: 'add-user' });
          }
        });
    },
    extendLimit() {
      this.$store.commit(`landlord/users/${mTypes.SET_LIMIT}`, this.usersLimit + 10);
      this.fetchUsers();
    },
    toggleMassEdit(isChecked) {
      this.isMassEdit = isChecked;

      if (!isChecked) {
        this.clearCheckedList();
      }
    },
    clearCheckedList() {
      this.checkedList = [];
    },
    addToCheckedList(id, isChecked) {
      if (isChecked) {
        const findItem = this.checkedList.find(item => item === id);

        if (!findItem) {
          this.checkedList = [
            ...this.checkedList,
            id,
          ];
        }
      } else {
        this.checkedList = this.checkedList.filter(item => item !== id);
      }
    },
    isFindOnCheckedList(id) {
      const findItem = this.checkedList.find(item => item === id);

      if (findItem) return true;

      return false;
    },
    showDeletingModal() {
      this.showDeleteConfirmationModal = true;
    },
    hideDeletingModal() {
      this.showDeleteConfirmationModal = false;
    },
    bulkDelete() {
      const checkedList = [...this.checkedList];
      this.hideDeletingModal();
      this.toggleMassEdit(false);

      this.$store.dispatch('users/user/deleteBulk', { user: this.user, ids: checkedList })
        .then(() => {
          this.$store.commit(`landlord/users/${mTypes.REMOVE_DATAS}`, checkedList);
          this.$router.push({ name: 'users' });
        });
    },
  },
  data() {
    return {
      isMassEdit: false,
      checkedList: [],
      showDeleteConfirmationModal: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/Sidebar.vue